import { getGroup } from '@db/Groups/Get';
import { uploadGroupPhoto } from '@db/Photos';
import db, { updateDocWithTimestamps } from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Photo } from '@types';
import { GroupFormData } from '@types';

export async function updateGroup(
  groupId: string,
  {
    displayName,
    description,
    adminIds,
  }: Pick<GroupFormData, 'displayName' | 'description' | 'adminIds'>,
  photo?: Photo
) {
  const existingGroup = await getGroup(groupId);
  let photoUrl: string = existingGroup.photoUrl;
  if (photo && photo.uri !== existingGroup.photoUrl) {
    const uploadedPhoto = await uploadGroupPhoto(groupId, photo);
    photoUrl = uploadedPhoto.uri;
  }
  await updateGroupDoc(groupId, {
    displayName,
    description,
    adminIds: [...new Set(adminIds)],
    photoUrl,
  });
}

export async function updateGroupDoc(groupId: string, data: Partial<GroupFormData>): Promise<void> {
  await updateDocWithTimestamps(db.doc(firestore, 'groups', groupId), data);
}
